import text from './resources/locale/en.json';

class PageNotFound {
    $onInit() {
        this.text = text;
    }
}

export default PageNotFound;
